module.exports = "/virtual-football-league/img/amblems/right/Spain/Fake_Barcelona.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Spain/Fake_Barcelona.png
// module id = 2150
// module chunks = 4